import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { useAppDispatch } from '../../app/redux/useAppSelector';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';
import handleUnresolveThreadError from '../comment/handleUnresolveThreadError';

const THREAD_FRAGMENT = gql(`
  fragment useUnresolveThread_thread on RootThreadFields {
    id
  }
`);

const UNRESOLVE_THREAD_MUTATION = gql(/** @complexity 2 */ `
  mutation unresolveThread($id: ID!) {
    unresolveThread(threadId: $id) {
      id
    }
  }
`);

const useUnresolveThread = () => {
  const dispatch = useAppDispatch();
  const [mutation] = useMutation(UNRESOLVE_THREAD_MUTATION);

  return useCallback(
    async (thread: DocumentType<typeof THREAD_FRAGMENT>) => {
      try {
        return await mutation({
          variables: { id: thread.id },
          optimisticResponse: { unresolveThread: { id: thread.id } },
          update: (cache) => {
            cache.modify({
              id: cache.identify(thread),
              fields: {
                resolvedAt: () => null,
              },
            });
          },
        });
      } catch (e) {
        handleUnresolveThreadError(e, dispatch);
        throw e;
      }
    },
    [mutation, dispatch],
  );
};

export default useUnresolveThread;
